import * as React from 'react';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import { RootNode } from '@strapi/blocks-react-renderer/dist/BlocksRenderer';
import * as styles from './StrapiTextRenderer.module.scss';
import clsx from 'clsx';

export const StrapiTextRenderer = ({
  content,
  withParagraphSpacings = true,
  className,
}: {
  content: RootNode[];
  withParagraphSpacings?: boolean;
  className?: string;
}) => (
  <BlocksRenderer
    content={content}
    blocks={{
      paragraph: ({ children }) => (
        <p className={clsx(styles.paragraph, withParagraphSpacings && styles.paragraph___wide, className)}>
          {children}
        </p>
      ),
      heading: ({ children, level }) => {
        if (level === 5 || level === 4) {
          return <h4 className={styles.header5}>{children}</h4>;
        }

        return <h4 className={styles.header}>{children}</h4>;
      },
      quote: ({ children }) => <blockquote className={styles.quote}>{children}</blockquote>,
      image: ({ image }) => <img className={styles.image} src={image.url} alt="" />,
    }}
    modifiers={{
      bold: ({ children }) => <strong>{children}</strong>,
      italic: ({ children }) => <span className="italic">{children}</span>,
    }}
  />
);
